import { render, staticRenderFns } from "./EmployeeKpi.vue?vue&type=template&id=40d2aca7&scoped=true"
import script from "./EmployeeKpi.vue?vue&type=script&lang=ts"
export * from "./EmployeeKpi.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeKpi.vue?vue&type=style&index=0&id=40d2aca7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d2aca7",
  null
  
)

export default component.exports